import { Obj } from '../entity.js'
import { ObjOptions } from './base.js'

export class SystemObj extends Obj<'System'> {
  readonly typeOf = 'System' as const

  public constructor(opts: ObjOptions) {
    super({ ...opts, typeOf: 'System' })
  }
}

export function isSystemObj(obj: any): obj is SystemObj {
  return obj.typeOf === 'System'
}
